import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { FuseSharedModule } from '../../../../../../@fuse/shared.module';
import { FuseNavbarVerticalComponentDynamic } from './style-dynamic.component';
import { AvatarModule } from 'ngx-avatars';
@NgModule({
    declarations: [
        FuseNavbarVerticalComponentDynamic
    ],
    imports     : [
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        FuseSharedModule,
        AvatarModule
    ],
    exports     : [
        FuseNavbarVerticalComponentDynamic
    ]
})
export class NavbarVerticalStyleDynamicModule
{
}
